import {
  PreparationSlipIndex,
  PreparationSlipEditor,
  PreparationSlipTemplateIndex,
  PreparationSlipTemplateEditor,
  PreparationSlipViewer,
  PreparationSlipTemplateViewer,
  AutomaticPrepSlipIndex
} from "../views";

export const preparationSlipRouter = {
  main: [
    {
      path: "preparation-slip",
      name: "PreparationSlipIndex",
      component: PreparationSlipIndex
    },
    {
      path: "preparation-slip/editor/:id?",
      name: "PreparationSlipEditor",
      component: PreparationSlipEditor,
      props: true
    },
    {
      path: "preparation-slip-template",
      name: "PreparationSlipTemplateIndex",
      component: PreparationSlipTemplateIndex
    },
    {
      path: "preparation-slip-template/editor/:id?",
      name: "PreparationSlipTemplateEditor",
      component: PreparationSlipTemplateEditor,
      props: true
    },
    {
      path: "preparation-slip-template/auto",
      name: "AutomaticPrepSlipIndex",
      component: AutomaticPrepSlipIndex
    }
  ],
  viewer: [
    {
      path: "preparation-slip/:id",
      name: "PreparationSlipViewer",
      component: PreparationSlipViewer,
      props: true
    },
    {
      path: "preparation-slip-template/viewer/:id?",
      name: "PreparationSlipTemplateViewer",
      component: PreparationSlipTemplateViewer,
      props: true
    }
  ]
};
